export function reorderData(data, activeItem, dataItem, direction) {
    if (activeItem === dataItem) {
        return data;
    }
    const reorderedData = data.slice();
    let prevIndex = reorderedData.findIndex((p) => p.id === activeItem.id);
    let nextIndex = reorderedData.findIndex((p) => p.id === dataItem.id) + (direction === "before" ? -1 : 0);
    if (prevIndex > nextIndex) {
        nextIndex++;
    }
    reorderedData.splice(prevIndex, 1);
    reorderedData.splice(nextIndex, 0, activeItem || reorderedData[0]);
    return reorderedData;
}

export function getAvailableEntities(entities, references) {
    return entities.filter(entity => (
        !references.some(reference => reference.entity.id === entity.id)
    ))
}

export function getAvailableRelations(relations, references) {
    return relations.filter(relation => (
        !references.some(reference => {
            return reference.relation && reference.relation._id === relation._id
        })
    ));
}

export function getAvailablePages(dataItem) {
    if (dataItem.relation && dataItem.relation.relationId === "attachment") {
        const attachmentPage = dataItem.entity.pages.find(page => page._id === "page-attachment");
        return attachmentPage ? [attachmentPage] : [];
    }
    return dataItem.entity.pages.filter(page => page._id !== "page-attachment");
}